import * as log from "loglevel";
import { inject, observer } from "mobx-react";
import * as React from "react";

import { Accordion } from "semantic-ui-react";
import { AuthStore } from "../../stores/auth-store";

import { AddReleaseNote } from "./add-release-note";
import { AddSystemMessage } from "./add-system-message";
import { CodingTool } from "./coding-tool";
import { EmailOptIn } from "./email-opt-in";
import { FetchJamPurgeList } from "./fetch-jam-purge-list";
import { FetchPurgeList } from "./fetch-purge-list";
import { SyncControls } from "./sync-controls";
//import { PermissionTemplateList } from "./permission-template-list";

interface IAdminViewProps{
	authStore ?: AuthStore;
}

interface IAdminViewState{
}


@inject("authStore") @observer
export class AdminView extends React.Component<IAdminViewProps, IAdminViewState>{
	constructor(props, state){
		super(props, state);
	}

	render(){
		let segments = [
			//Sync section
			{
				"title": "Sync Controls",
				"content": {
					"key": "sync-controls",
					"content": (
						<SyncControls />
					)
				}
			},
			... this.props.authStore.user.hasPowerAccess() ? [{
				"title": "Release Notes",
				"content": {
					"key": "release-notes",
					"content": (
						<AddReleaseNote />
					)
				}
			}] : [],
			... (this.props.authStore.user.hasPowerAccess()) ? [{
				"title": "System Message",
				"content": {
					"key": "system-message",
					"content": (
						<AddSystemMessage />
					)
				}
			}] : [],
			{
				"title": "Email Opt-In",
				"content": {
					"key": "email-opt-in",
					"content": (
						<EmailOptIn />
					)
				}
			},
			{
				"title": "Survey Purge",
				"content": {
					"key": "purge-action",
					"content": (
						<FetchPurgeList />
					)
				}
			},
			{
				"title": "Application Manager App Purge",
				"content": {
					"key": "jam-purge-action",
					"content": (
						<FetchJamPurgeList />
					)
				}
			},
			{
				"title": "Coding Tool",
				"content": {
					"key": "coding-tool",
					"content": (
						<CodingTool />
					)
				}
			},
			// {
			// 	"title": "Release new Terms and Conditions",
			// 	"content": {
			// 		"key": "new-terms-and-conditions",
			// 		"content": (
			// 			<NewTermsAndConditions />
			// 		)
			// 	}
			// }
		];
		return (
			<div style={{"paddingTop": "20px", "marginLeft": "150px", "marginRight": "150px"}}>
				<Accordion panels={segments} defaultActiveIndex={0} styled style={{"width": "100%"}}/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/admin/admin-view.tsx